// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"89ed576f","353":"6cb959f4","355":"5735f20a","399":"b6fcf48e","472":"bd92ff2c","492":"9b53d4de","602":"4a25b743","710":"00778136","913":"1642b01f","922":"70d45dbc","971":"436cb545"}[chunkId] + ".chunk.js";
};